import { Component, OnInit } from '@angular/core';
import { Observable, Subscription, filter } from 'rxjs';
import { ChartType } from '../../services/forbruk/forbruk.types';
import { SpotService } from '../../services/spot/spot.service';
import { registerLocaleData } from '@angular/common';
import localeNb from '@angular/common/locales/nb';
import {
  Dager,
  PrisDager,
  Priser,
  Prisomraade,
  SpotprisResponse
} from '../../services/spot/spot.types';
import { AvtaleResponse } from '../../services/avtale/avtale.types';
import { AvtaleService } from '../../services/avtale/avtale.service';
import { DataService } from '../../services/datatransfer/DataService';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import {
  AlertController,
  Platform,
  RefresherCustomEvent
} from '@ionic/angular';
import { CustomLocaleNb, theTime } from 'src/app/utils/date-utils';
import AirDatepicker from 'air-datepicker';
import {
  getDayDictKey,
  getStromstotteHour,
  getSupportLevel,
  getSupportLevelMva
} from './spot-utils';
import { isSameDay, isSameMonth } from 'date-fns';
import { Router, RouterEvent } from '@angular/router';
import { SanityService } from 'src/app/services/sanity/sanity.service';
import { GraphDescription } from 'src/app/services/sanity/sanity.types';
import { InformationService } from 'src/app/services/notify/information.service';
import { InformationMessage } from 'src/app/services/notify/information.types';
registerLocaleData(localeNb, 'nb');

@Component({
  selector: 'app-spot',
  templateUrl: './spot.page.html',
  styleUrls: ['./spot.page.scss']
})
export class SpotPage implements OnInit {
  _chartTypes: ChartType;
  showYearCal = false;
  showMonthCal = false;
  showDayCal = false;

  dayDatepicker: AirDatepicker<HTMLElement>;
  hourDatepicker: AirDatepicker<HTMLElement>;

  startDate: Date;
  maxDate: Date;
  minDate: Date;

  selectedYear: Date;
  selectedMonth: Date;
  selectedDay: Date;

  valgtPrisomraade: Prisomraade;
  prisomraader: Prisomraade[];

  extraPrisomraader: Prisomraade[];

  //_maanedResponse: Observable<SpotprisResponse>;
  _dagResponse: Observable<SpotprisResponse>;
  _timeResponse: Observable<SpotprisResponse>;
  hasFetchingError: boolean;

  dayDictionary: Map<string, SpotprisResponse>;
  hourDictionary: Map<string, SpotprisResponse>;
  prisDagerDay: PrisDager[];
  prisDagerHour: PrisDager[];

  monthBack: boolean;
  monthForward: boolean;

  dayBack: boolean;
  dayForward: boolean;

  hourBack: boolean;
  hourForward: boolean;

  tomorrowInit = false;

  showTableDay = false;
  showTableHour = false;

  areaLoading: boolean;

  aboutAreas: GraphDescription;

  _avtaleResponse: Observable<AvtaleResponse>;
  _avtaler: AvtaleResponse;

  subscription: Subscription;
  subscriptionInit = false;

  // John Even SKAL ha fastpris i appen...
  isJohnEven = false;
  fastprisJohnEven: number;

  avtaleSubscription: Subscription;
  dagsResponseSubscription: Subscription;
  timeResponseSubscription: Subscription;
  routerSubscription: Subscription;

  infoMessages: InformationMessage[] = [];

  // Strømstøtte
  showStromstotte = true;
  stromstotteHour: PrisDager[];
  hasStotteHour: boolean;
  stromstotteDay: PrisDager[];
  hasStotteDay: boolean;

  constructor(
    private analyticsService: AnalyticsService,
    private sanityService: SanityService,
    private _avtaleService: AvtaleService,
    private dataService: DataService,
    private _spotService: SpotService,
    private router: Router,
    public platform: Platform,
    public infoService: InformationService,
    private alertController: AlertController
  ) {
    this.startDate = new Date();
    //this.startDate = this.addDays(this.startDate, -1);
    this.maxDate = this.startDate;

    //this.minDate = this.addYear(this.startDate, -7);
    this.minDate = new Date(this.startDate.getFullYear() - 2, 0, 1, 0, 0, 0);
    this.selectedYear = this.startDate;
    this.selectedMonth = this.startDate;
    this.selectedDay = this.startDate;

    this.monthBack = true;
    this.monthForward = false;

    this.dayBack = true;
    this.dayForward = false;

    this.hourBack = true;
    this.hourForward = false;

    this._chartTypes = {
      Aar: { active: false, name: 'År', visible: false },
      Maaned: { active: false, name: 'Måned', visible: false },
      Dag: { active: false, name: 'Dag', visible: true },
      Time: { active: false, name: 'Time', visible: true }
    };

    // Listen for router events
    router.events
      .pipe(
        filter(
          (e: any): e is RouterEvent =>
            e instanceof RouterEvent && e.url.includes('spot')
        )
      )
      .subscribe((e: RouterEvent) => {
        this.navigateToCorrectTab();
      });

    this.navigateToCorrectTab();

    this.dayDictionary = new Map<string, SpotprisResponse>();
    this.hourDictionary = new Map<string, SpotprisResponse>();

    this.hasFetchingError = false;
  }

  navigateToCorrectTab() {
    const navState = this.router.lastSuccessfulNavigation?.extras?.state;
    const activeChartProp = navState?.activeChart;
    const presentationProp = navState?.presentation;

    if (activeChartProp) {
      if (presentationProp && activeChartProp === 'Time') {
        this._chartTypes.Time.active = true;
        this._chartTypes.Dag.active = false;
        this.showTableHour = true;
        this.updateHourChart(true);
      } else if (presentationProp && activeChartProp === 'Dag') {
        this._chartTypes.Dag.active = true;
        this._chartTypes.Time.active = false;
        this.showTableDay = true;
        this.updateDayChart(true);
      } else {
        this._chartTypes.Dag.active = false;
        this._chartTypes.Time.active = false;
        this._chartTypes[activeChartProp].active = true;
      }
    } else {
      this._chartTypes.Dag.active = true;
      this._chartTypes.Time.active = false;
    }
  }

  ngOnInit(): void {
    this.prisomraader = [
      {
        antAnlegg: 0,
        omraade: 'NO1',
        friendly: 'NO1 - Sørøst-Norge',
        valgt: false
      },
      {
        antAnlegg: 0,
        omraade: 'NO2',
        friendly: 'NO2 - Sørvest-Norge',
        valgt: false
      },
      {
        antAnlegg: 0,
        omraade: 'NO3',
        friendly: 'NO3 - Midt-Norge',
        valgt: false
      },
      {
        antAnlegg: 0,
        omraade: 'NO4',
        friendly: 'NO4 - Nord-Norge',
        valgt: false
      },
      {
        antAnlegg: 0,
        omraade: 'NO5',
        friendly: 'NO5 - Vest-Norge',
        valgt: false
      }
    ];
    this.areaLoading = true;
    this.valgtPrisomraade = this.prisomraader[0];

    this.extraPrisomraader = this.prisomraader;

    this._avtaleResponse = this._avtaleService.getAvtaler();
    this.avtaleSubscription = this._avtaleResponse.subscribe({
      next: (res) => {
        if (res?.avtaler) {
          this._avtaler = res;
          res.avtaler.forEach((avtale) => {
            this.prisomraader.forEach((o) => {
              if (o.omraade == avtale.prisomrade) {
                o.antAnlegg++;
                this.valgtPrisomraade = o;
              }
            });
            this.areaLoading = false;
            if (
              avtale.produktgruppe === 'Fastpris' &&
              avtale.objectid === '707057500024079373'
            ) {
              this.isJohnEven = true;
              this.fastprisJohnEven = avtale.sistePris;
            }
          });
        }

        this.updateChart('ngOnInit');
      },
      error: (err) => {
        this.hasFetchingError = true;
      }
    });

    this.sanityService.getGraphDescriptions().then((res) => {
      this.aboutAreas = res.app_spot;
    });

    if (!this.subscriptionInit) this.setupDataChangeListener();

    this.infoService.getInfoMessages().subscribe({
      next: (res) => {
        this.infoMessages = res.filter((x) => x.aktivert) || [];
      }
    });
  }

  ionViewWillLeave() {
    this.avtaleSubscription?.unsubscribe();
    this.subscription?.unsubscribe();
    this.dagsResponseSubscription?.unsubscribe();
    this.timeResponseSubscription?.unsubscribe();
  }
  setupDataChangeListener() {
    this.subscription = this.dataService.getKundebytte().subscribe((x) => {
      if (x) {
        this.ngOnInit();
      }
    });

    this.subscriptionInit = true;
  }

  selectAdditionalOmraade(omrIndex: number) {
    // Give list new reference to trigger change detection
    this.extraPrisomraader = this.extraPrisomraader.map((o, i) => {
      if (i === omrIndex) {
        return {
          ...o,
          valgt: !o.valgt
        };
      } else {
        return o;
      }
    });

    // this.updateChart('selectedAdditionalOmraader');
  }

  addHours(date, hours) {
    const result = new Date(date);
    result.setHours(result.getHours() + hours);
    return result;
  }
  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  addMonth(date, months) {
    const result = new Date(date);

    // Set the date to the first of the month to avoid issues with months that have less days than the current date
    result.setDate(1);

    result.setMonth(result.getMonth() + months);

    if (date.getMonth() == result.getMonth()) {
      result.setMonth(result.getMonth() + months);
    }

    return result;
  }
  addYear(date, years) {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  }

  reloadChart() {
    this.extraPrisomraader.forEach(function(item) {
      item.valgt = false;
    });

    this.dayDatepicker.update({ maxDate: this.maxDate });
    this.dayDatepicker.selectDate(this.selectedMonth);

    this.hourDatepicker.update({ maxDate: this.maxDate });
    this.hourDatepicker.selectDate(this.selectedDay);
  }

  updateChart(caller: string) {
    this.hasFetchingError = false;
    if (this._chartTypes.Dag.active) {
      this.updateDayChart();
    }
    if (this._chartTypes.Time.active) {
      this.updateHourChart();
    }
  }

  updateDayChart(shouldReloadTomorrow = false) {
    const dayKey = getDayDictKey(this.selectedMonth);
    const dayData = this.dayDictionary.get(dayKey);
    const hasTomorrowPrices = dayData?.harMorgendagensPriser;
    const isAfter13 = new Date().getHours() >= 13;

    if (
      shouldReloadTomorrow ||
      !dayData ||
      (isAfter13 &&
        !hasTomorrowPrices &&
        isSameMonth(this.selectedMonth, new Date()))
    ) {
      this.prisDagerDay = undefined;
      this._dagResponse = this._spotService.getDagspot(this.selectedMonth);
      this.dagsResponseSubscription = this._dagResponse.subscribe({
        next: (m) => {
          // Check if the response is for the current month
          if (
            m.prisDager[0].dager[0].dato.substring(0, 7) !=
            theTime(this.selectedMonth).to(['YYYY', 'MM'], '-')
          ) {
            return;
          }

          this.prisDagerDay = m.prisDager.filter((x) => x.omrade !== 'SYS');
          this.applyStromstotte();
          if (m.ok) {
            this.dayDictionary.set(dayKey, m);
            this.checkTomorrow(m, shouldReloadTomorrow);
            const nextDate = new Date(m.next);
            if (nextDate > this.maxDate) {
              this.maxDate = nextDate;
            }
          }
        },
        error: (err) => {
          this.hasFetchingError = true;
        }
      });
    } else {
      this.prisDagerDay = dayData.prisDager.filter((x) => x.omrade !== 'SYS');
      this.applyStromstotte();
    }
  }

  updateHourChart(shouldReloadTomorrow = false) {
    const hourKey = getDayDictKey(this.selectedDay);
    const hourData = this.hourDictionary.get(hourKey);
    const hasTomorrowPrices = hourData?.harMorgendagensPriser;
    const isAfter13 = new Date().getHours() >= 13;

    if (
      shouldReloadTomorrow ||
      !hourData ||
      (isAfter13 &&
        !hasTomorrowPrices &&
        isSameDay(this.selectedDay, new Date()))
    ) {
      this.prisDagerHour = undefined;
      this._timeResponse = this._spotService.getTimespot(this.selectedDay);
      this.timeResponseSubscription = this._timeResponse.subscribe({
        next: (m) => {
          this.prisDagerHour = m.prisDager.filter((x) => x.omrade !== 'SYS');
          this.applyStromstotte();
          if (m.ok) {
            this.hourDictionary.set(hourKey, m);
            this.checkTomorrow(m, shouldReloadTomorrow);
            const nextDate = new Date(m.next);
            if (nextDate > this.maxDate) {
              this.maxDate = nextDate;
            }
          }
        },
        error: (err) => {
          this.hasFetchingError = true;
        }
      });
    } else {
      this.prisDagerHour = hourData.prisDager.filter((x) => x.omrade !== 'SYS');
      this.applyStromstotte();
    }
  }

  checkTomorrow(m: SpotprisResponse, shouldReload = false) {
    this.maxDate = this.addDays(new Date(), m.harMorgendagensPriser ? 1 : 0);
    this.dayDatepicker.update({ maxDate: this.maxDate });
    this.hourDatepicker.update({ maxDate: this.maxDate });

    if (shouldReload) {
      if (m.harMorgendagensPriser) {
        this.selectedDay = this.maxDate;
        this.selectedMonth = this.maxDate;
      }
      this.dayDatepicker.selectDate(this.selectedMonth);
      this.hourDatepicker.selectDate(this.selectedDay);
    }

    this.checkDateLimits('month');
    this.checkDateLimits('day');
  }

  ngAfterViewInit() {
    this.dayDatepicker = new AirDatepicker('#airspotDay', {
      startDate: this.startDate,
      locale: CustomLocaleNb,
      maxDate: this.maxDate,
      minDate: this.minDate,
      range: false,
      toggleSelected: false,
      view: 'months',
      minView: 'months',
      autoClose: true,
      dateFormat: 'MMMM yyyy',
      onSelect: function(date: Date) {
        if (date['formattedDate']) {
          this.setSelectedDate('month', date['date']);
          if (this.selectedMonth != date['date']) this.showHideCal('month');
        }
      }.bind(this)
    });
    this.dayDatepicker.selectDate(this.startDate);

    this.hourDatepicker = new AirDatepicker('#airspotHour', {
      startDate: this.startDate,
      locale: CustomLocaleNb,
      maxDate: this.maxDate,
      minDate: this.minDate,
      range: false,
      toggleSelected: false,
      view: 'days',
      minView: 'days',
      autoClose: true,
      dateFormat: 'dd. MMMM yyyy',
      onSelect: function(date: Date) {
        if (date['formattedDate']) {
          this.setSelectedDate('day', date['date']);
          if (this.selectedDay != date['date']) this.showHideCal('day');
        }
      }.bind(this)
    });
    this.hourDatepicker.selectDate(this.startDate);
  }

  showHideCal(chart: string) {
    if (chart == 'day') {
      this.showDayCal = !this.showDayCal;
    }
    if (chart == 'month') {
      this.showMonthCal = !this.showMonthCal;
    }
    if (chart == 'year') {
      this.showYearCal = !this.showYearCal;
    }
  }

  setSelectedDate(chart: string, value: Date) {
    if (chart == 'year') {
      this.selectedYear = value;
      this.checkDateLimits(chart);
    }
    if (chart == 'month') {
      this.selectedMonth = value;
      if (this.selectedMonth.getHours() == 0) {
        this.selectedMonth = this.addHours(this.selectedMonth, 6);
      }
      this.checkDateLimits(chart);
    }
    if (chart == 'day') {
      this.selectedDay = value;
      if (this.selectedDay.getHours() == 0)
        this.selectedDay = this.addHours(this.selectedDay, 6);
      this.checkDateLimits(chart);
    }

    if (
      (chart == 'year' && this._chartTypes.Maaned.active) ||
      (chart == 'month' && this._chartTypes.Dag.active) ||
      (chart == 'day' && this._chartTypes.Time.active)
    )
      this.updateChart('setSelectedDate');
  }

  moveBack(chart: string) {
    if (chart == 'year') {
      this.checkDateLimits(chart);
      if (this.monthBack) {
        this.analyticsService.logEvent_selectContent(
          'spot måned browse bakover'
        );
        this.selectedYear = this.addYear(this.selectedYear, -1);
        this.checkDateLimits(chart);
      }
    }
    if (chart == 'month') {
      this.checkDateLimits(chart);
      if (this.dayBack) {
        this.analyticsService.logEvent_selectContent('spot dag browse bakover');
        this.dayDatepicker.selectDate(this.addMonth(this.selectedMonth, -1));
      }
    }
    if (chart == 'day') {
      this.checkDateLimits(chart);
      if (this.hourBack) {
        this.analyticsService.logEvent_selectContent(
          'spot time browse bakover'
        );
        this.hourDatepicker.selectDate(this.addDays(this.selectedDay, -1));
      }
    }
  }

  moveForth(chart: string) {
    if (chart == 'year') {
      this.checkDateLimits(chart);
      if (this.monthForward) {
        this.analyticsService.logEvent_selectContent(
          'spot måned browse fremover'
        );
        this.selectedYear = this.addYear(this.selectedYear, 1);
      }
    }
    if (chart == 'month') {
      this.checkDateLimits(chart);
      if (this.dayForward) {
        this.analyticsService.logEvent_selectContent(
          'spot dag browse fremover'
        );
        this.dayDatepicker.selectDate(this.addMonth(this.selectedMonth, 1));
      }
    }
    if (chart == 'day') {
      this.checkDateLimits(chart);
      if (this.hourForward) {
        this.analyticsService.logEvent_selectContent(
          'spot time browse fremover'
        );
        this.hourDatepicker.selectDate(this.addDays(this.selectedDay, 1));
      }
    }
  }

  checkDateLimits(chart: string) {
    const primMax = new Date(
      this.maxDate.getFullYear(),
      this.maxDate.getMonth(),
      this.maxDate.getDate(),
      0,
      0,
      0
    );
    const primMin = new Date(
      this.minDate.getFullYear(),
      this.minDate.getMonth(),
      this.minDate.getDate(),
      0,
      0,
      0
    );

    let primSel: Date;
    if (chart == 'year') {
      this.monthBack =
        this.selectedYear.getFullYear() <= this.minDate.getFullYear()
          ? false
          : true;
      this.monthForward =
        this.selectedYear.getFullYear() >= this.maxDate.getFullYear()
          ? false
          : true;
    }
    if (chart == 'month') {
      primSel = new Date(
        this.selectedMonth.getFullYear(),
        this.selectedMonth.getMonth(),
        1,
        0,
        0,
        0
      );
      const primMinMonth = new Date(
        this.minDate.getFullYear(),
        this.minDate.getMonth(),
        1,
        0,
        0,
        0
      );
      const primMaxMonth = new Date(
        this.maxDate.getFullYear(),
        this.maxDate.getMonth(),
        1,
        0,
        0,
        0
      );

      this.dayBack = primSel <= primMinMonth ? false : true;
      this.dayForward = primSel >= primMaxMonth ? false : true;
    }
    if (chart == 'day') {
      primSel = new Date(
        this.selectedDay.getFullYear(),
        this.selectedDay.getMonth(),
        this.selectedDay.getDate(),
        0,
        0,
        0
      );

      this.hourBack = primSel <= primMin ? false : true;
      this.hourForward = primSel >= primMax ? false : true;
    }
  }

  selectChartType(type: string) {
    this.analyticsService.logEvent_selectContent(
      'spot bytt visning til ' + type
    );

    this.showYearCal = false;
    this.showMonthCal = false;
    this.showDayCal = false;

    for (const key in this._chartTypes) {
      if (key !== type) {
        this._chartTypes[key].active = false;
      } else {
        this._chartTypes[key].active = true;
      }
    }
    this.updateChart('selectSpotType ' + type);
  }

  async doRefresh(myevent: RefresherCustomEvent) {
    this.dayDictionary = new Map<string, SpotprisResponse>();
    this.hourDictionary = new Map<string, SpotprisResponse>();
    this.prisDagerDay = undefined;
    this.prisDagerHour = undefined;
    this.updateChart('refresh');
    myevent.detail.complete();
  }

  toggleTableDay() {
    this.showTableDay = !this.showTableDay;
    if (this.showTableDay) {
      this.analyticsService.logEvent_selectContent('spot vis tabell dag');
    }
  }
  toggleTableHour() {
    this.showTableHour = !this.showTableHour;
    if (this.showTableHour) {
      this.analyticsService.logEvent_selectContent('spot vis tabell time');
    }
  }

  async expandAreaTooltip() {
    const alert = await this.alertController.create({
      header: 'Om prisområdene',
      message:
        'NO1 er Sørøst-Norge, NO2 er Sørvest-Norge, NO3 er Midt-Norge, NO4 er Nord-Norge og NO5 er Vest-Norge.',
      cssClass: 'push-alert',
      mode: 'ios',
      backdropDismiss: true,
      buttons: ['Lukk']
    });
    await alert.present();
  }

  toggleStromstotte() {
    this.showStromstotte = !this.showStromstotte;
    this.applyStromstotte();
  }

  applyStromstotte() {
    if (this.showStromstotte) {
      this.calcStromstotteData();
    } else {
      this.stromstotteDay = undefined;
      this.stromstotteHour = undefined;
    }
  }

  calcStromstotteData() {
    this.stromstotteDay = this.prisDagerDay?.map((x: PrisDager) => {
      let omradeHasStotte = false;
      const stotteYear = this.selectedMonth.getFullYear();
      if (stotteYear < 2024) {
        return x;
      }
      const supportLevel = getSupportLevel(stotteYear);
      const supportLevelMva = getSupportLevelMva(stotteYear);
      const omradeSupportLevel =
        x.omrade === 'NO4' ? supportLevel : supportLevelMva;

      const dagerMedStotte = x.dager.map((y: Dager) => {
        const priserStotte = y.priser.map((z: Priser) => ({
          ...z,
          pris:
            z.pris <= omradeSupportLevel
              ? z.pris
              : z.pris - getStromstotteHour(z.pris, x.omrade, stotteYear)
        }));

        if (y.priser.some((p) => p.pris > omradeSupportLevel)) {
          omradeHasStotte = true;
        }

        return {
          ...y,
          priser: priserStotte,
          dognpris:
            // Snittpris for døgnet med timesbasert strømstøtte
            priserStotte.reduce((acc, curr) => curr.pris + acc, 0) /
            priserStotte.length
        };
      });

      if (x.omrade === this.valgtPrisomraade.omraade) {
        this.hasStotteDay = omradeHasStotte;
      }

      return {
        ...x,
        dager: dagerMedStotte
      };
    });

    this.stromstotteHour = this.prisDagerHour?.map((x) => ({
      ...x,
      dager: x.dager.map((y) => {
        const stotteYear = this.selectedDay.getFullYear();
        if (stotteYear < 2024) {
          return y;
        }
        const supportLevel = getSupportLevel(stotteYear);
        const supportLevelMva = getSupportLevelMva(stotteYear);
        const omradeSupportLevel =
          x.omrade === 'NO4' ? supportLevel : supportLevelMva;
        if (x.omrade === this.valgtPrisomraade.omraade) {
          this.hasStotteHour = y.priser.some(
            (p) => p.pris > omradeSupportLevel
          );
        }
        return {
          ...y,
          priser: y.priser.map((z) => ({
            ...z,
            pris:
              z.pris <= omradeSupportLevel
                ? z.pris
                : z.pris - getStromstotteHour(z.pris, x.omrade, stotteYear)
          }))
        };
      })
    }));
  }
}
